import gql from 'graphql-tag';

export const alarmScheduleTableFields = gql`
  fragment AlarmScheduleTableFields on AlarmScheduleTable {
    id
    ownerType
    partnerId
    condominiumId
    name
    description
    days
    appliesOnHolidays
    armToleranceMinutes
    disarmToleranceMinutes
    intervals {
      id
      startTime
      endTime
    }
    scheduleKind
    specificDates {
      year
      month
      day
    }
  }
`;

export const alarmCentralDeviceFields = gql`
  fragment AlarmCentralDeviceFields on AlarmCentralDevice {
    deviceId
    name
    deviceTypeId
  }
`;

export const alarmScheduleMutationResponseFields = gql`
  fragment AlarmScheduleMutationResponseFields on AlarmScheduleMutationResponse {
    result
    id
  }
`;

export const alarmScheduleTableAssignmentTargetFields = gql`
  fragment AlarmScheduleTableAssignmentTargetFields on AlarmScheduleTableAssignmentTarget {
    id
    deviceId
    alarmPartitionId
  }
`;

export const alarmScheduleTableAssignmentFields = gql`
  fragment AlarmScheduleTableAssignmentFields on AlarmScheduleTableAssignment {
    id
    condominiumId
    alarmScheduleTableId
    targets {
      ...AlarmScheduleTableAssignmentTargetFields
    }
  }
  ${alarmScheduleTableAssignmentTargetFields}
`;

export const alarmPartitionStatusFields = gql`
  fragment AlarmPartitionStatusFields on AlarmPartitionStatus {
    partition
    status
    alarmState
    alarmStateChangedDate
    lastNotArmedDate
    lastNotDisarmedDate
  }
`;

export const alarmDeviceStatusFields = gql`
  fragment AlarmDeviceStatusFields on AlarmDeviceStatus {
    deviceId
    name
    deviceTypeId
    status
    partitions {
      ...AlarmPartitionStatusFields
    }
  }
  ${alarmPartitionStatusFields}
`;

export const alarmDeviceScheduleResolutionFields = gql`
  fragment AlarmDeviceScheduleResolutionFields on AlarmDeviceScheduleResolution {
    deviceId
    name
    deviceTypeId
    partitions {
      partition
      scheduleTable {
        ...AlarmScheduleTableFields
      }
    }
  }
  ${alarmScheduleTableFields}
`;

export const alarmCondominiumStatusFields = gql`
  fragment AlarmCondominiumStatusFields on AlarmCondominiumStatus {
    overallStatus
    devices {
      ...AlarmDeviceStatusFields
    }
  }
  ${alarmDeviceStatusFields}
`;
